<template>
  <transition name="fade">
    <div class="toast" v-if="visible" @click="dismiss">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    message: String,
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dismiss() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
.toast {
  /* 你的样式 */
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  z-index: 999999;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .toast{
    top: 40%;
    transform: translateX(-50%,-40%);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Toast.vue